import request from '../utils/request'

/**
 * 获取首页轮播图
 */
export function getBanner () {
  return request({
    url: '/app/banner',
    method: 'post'
  })
}

/**
 * 获取使用帮助链接
 */
export function getUserHelpLink () {
  return request({
    url: '/app/help_link',
    method: 'post'
  })
}
